import angular from 'angular';
import wageAdvanceFormComponent from './wageAdvanceForm.component';

let wageAdvanceFormModule = angular.module('wageAdvanceForm', [])

  .component('wageAdvanceForm', wageAdvanceFormComponent)

  .name;

export default wageAdvanceFormModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceForm/wageAdvanceForm.js